var _clipPath, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.35 3.35h26.41v19.21h-26.41z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 0 27.91)",
    gradientUnits: "userSpaceOnUse",
    x1: 6.35,
    x2: 14.49,
    y1: 14.96,
    y2: 14.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#313578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077bd"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 27.91)",
    gradientUnits: "userSpaceOnUse",
    x1: 15.52,
    x2: 23.65,
    y1: 14.96,
    y2: 14.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#763137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee1846"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 0 27.91)",
    gradientUnits: "userSpaceOnUse",
    x1: 26.23,
    x2: 29.05,
    y1: 13.71,
    y2: 13.71
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62bb45"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 78.11,
    x2: 84.88,
    xlinkHref: "#d",
    y1: 16.3,
    y2: 16.3
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 174.04,
    x2: 240.41,
    xlinkHref: "#d",
    y1: 14.97,
    y2: 14.97
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.56 3.35a3.35 3.35 0 0 0 -2.23.94 3.17 3.17 0 0 0 -1 2.16v8a9.41 9.41 0 0 0 2.38.69c1.3.08 2.1-.33 2.23-1.38v-3.87h2.86v3.84c-.15 2.11-2.12 2.6-5.12 2.45a14.31 14.31 0 0 1 -2.35-.34v6.72h5a3.34 3.34 0 0 0 2.2-1 3.21 3.21 0 0 0 .94-2.15v-16.06z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.72 3.35a3.37 3.37 0 0 0 -2.22.94 3.16 3.16 0 0 0 -1 2.16v4.25a6.93 6.93 0 0 1 4.67-1 14.12 14.12 0 0 1 2.5.38v1.35a7.42 7.42 0 0 0 -2.4-.68c-2-.14-3 .74-3 2.17s.78 2.38 3 2.23a8.67 8.67 0 0 0 2.4-.68v1.33a13.13 13.13 0 0 1 -3.06.43 6.77 6.77 0 0 1 -4.12-1v7.31h4.94a3.34 3.34 0 0 0 2.2-1 3.17 3.17 0 0 0 .94-2.15v-16.04z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.19 13.35h-2v1.7h2a.92.92 0 0 0 .61-.26.86.86 0 0 0 .25-.6.84.84 0 0 0 -.25-.6.9.9 0 0 0 -.61-.24z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.82 11.64a.76.76 0 0 0 -.05-.3.78.78 0 0 0 -.17-.26.68.68 0 0 0 -.26-.18.78.78 0 0 0 -.31-.07h-1.8v1.56h1.89a.75.75 0 0 0 .49-.25.78.78 0 0 0 .21-.5z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.84 3.35a3.39 3.39 0 0 0 -2.23.94 3.2 3.2 0 0 0 -1 2.16v3.42h4.75c1 0 2.06.4 2.06 1.51 0 .6-.33 1.28-1.52 1.5a1.79 1.79 0 0 1 .69.08 1.93 1.93 0 0 1 .6.32 1.79 1.79 0 0 1 .42.53 1.47 1.47 0 0 1 .18.64c0 1.22-1.29 1.56-2 1.56h-5.2v6.52h4.95a3.32 3.32 0 0 0 2.19-1 3.15 3.15 0 0 0 .94-2.15v-16.03z",
    fill: "url(#f)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardJcb);
export default __webpack_public_path__ + "static/media/card-jcb.8f451b0ef70cd7e1518ed681eb380707.svg";
export { ForwardRef as ReactComponent };